import { render, staticRenderFns } from "./DownloadAssessmentDataButtons.vue?vue&type=template&id=4773cba6&"
import script from "./DownloadAssessmentDataButtons.vue?vue&type=script&lang=js&"
export * from "./DownloadAssessmentDataButtons.vue?vue&type=script&lang=js&"
import style0 from "./DownloadAssessmentDataButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/builds/iaai/products/maturity-assessment-tool/mat-website/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4773cba6')) {
      api.createRecord('4773cba6', component.options)
    } else {
      api.reload('4773cba6', component.options)
    }
    module.hot.accept("./DownloadAssessmentDataButtons.vue?vue&type=template&id=4773cba6&", function () {
      api.rerender('4773cba6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DownloadAssessmentDataButtons.vue"
export default component.exports